import yearContainer from "../../../assets/images/home/year-container.svg";

const Establishment = ({ data }) => (
  <div className="mnara-bg grid md:grid-cols-2 gap-8 md:gap-0 md:pt-40 py-28 md:pb-80 px-6 md:px-10 lg:px-20">
    <div className="text-white">
      <h2 className="text-4xl mb-10">Our Establishment</h2>

      <p className="xl:text-lg md:pl-3 lg:pl-6 break-all">
        {data?.establishment}
      </p>
    </div>

    <div className="flex justify-center items-center">
      <div className="relative">
        <img
          src={yearContainer}
          alt="Year Container"
          className="w-60 lg:w-80"
        />
        <h4 className="absolute right-1/4 lg:right-1/3 bottom-12 lg:bottom-20 text-white text-6xl">
          1900
        </h4>
      </div>
    </div>
  </div>
);

export default Establishment;
